import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { GeneralService } from "../services/general.service";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Router } from "@angular/router";
import { RechercheComponent } from "../recherche/recherche.component";
declare var $: any;
@Component({
  selector: "app-groupe-categorie",
  templateUrl: "./groupe-categorie.component.html",
  styleUrls: ["./groupe-categorie.component.scss"],
  animations: [
    trigger("detailExpand", [
      state(
        "collapsed",
        style({ height: "0px", minHeight: "0", display: "none" })
      ),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class GroupeCategorieComponent implements OnInit {
  constructor(private router: Router, public generalService: GeneralService) {}
  @ViewChild(RechercheComponent) rechercheComponent;
  groupe = {
    ecGroup_Code: "",
    ecGroup_Label: "",
    ecGroup_Ordre: "",
    ecGroup_Icone: "assets/icon.png",
    Art_Code: null,
    ecGroup_Statut: null,
    ecGroup_Pos: null,
  };
  groupeMenue;
  azerty; // ne pas supprimer
  dataSourceGroupes = new MatTableDataSource([]);
  dataSourceMenue = new MatTableDataSource([]);
  categories = [];
  allCategories = [];

  famille = { famille_Code: "", famille_Text: "" };
  categorieSelected;
  categorieNiveau2Selected;
  rowGroupe;
  rowMenue;
  rowArticle;
  displayedColumnsMenues = [
    "colExp",
    "ecGroupMenu_Code",
    "ecGroupMenu_Label",
    "ecGroupMenu_Id",
    "action",
  ];
  displayedColumnsGroupes = [
    "ecGroup_Icone",
    "ecGroup_Code",
    "ecGroup_Label",
    "ecGroup_Ordre",
    "ecGroup_Statut",
    "ecGroup_Pos",
  ];
  displayedColumnsArticle = ["Art_Code", "Art_Des", "Art_Ord"];
  listeGroupes;
  categoriesNiveau2;
  allGroupe = [];
  allMenu;
  menues;
  allArticlesMenue;
  articlesMenu;
  showMenu = false;
  oldIdMenue;
  oldIdArticle;
  disabled;
  parentVal;
  enregistrementTerminer = true;
  imagesCategorie;
  imageCategorieSrc;
  imageCategorieName: string;
  imageCategorieForUpdateIsLodet: boolean = false;
  disabledBtnSupprimerGroupe: boolean = false;
  disabledBtnSupprimerArticleMenue: boolean = false;
  initDoc;
  selectedCategorie;
  //
  file;
  base_url = this.generalService.base_url;
  imageToUpload = { base64: null, name: "", code: "" };
  lastRowFocus = { id: 0, order: 0 };
  onFocusOrder(id, order) {
    this.lastRowFocus.id = id;
    this.lastRowFocus.order = order;
  }
  onBlurOrder(id, order) {
    if (this.lastRowFocus.id == id && this.lastRowFocus.order != order) {
      this.enregistrementTerminer = false;
      this.generalService
        .rechercheTable(
          this.generalService.urlGroupArt + "&val=" + this.lastRowFocus.id
        )
        .subscribe(
          (artGroupe) => {
            artGroupe.ecGroupArt[0].ecGroup_Ordre = order;
            this.generalService.enregisterTable(artGroupe).subscribe(
              (artGroupe) => {
                this.enregistrementTerminer = true;
                this.generalService.dialogSuccess("Article enregisté", true);
                // this.getMenu(true);
                this.lastRowFocus = { id: 0, order: 0 };
              },
              (err) => {
                this.generalService.dialogSuccess(
                  "Une erreur se produite",
                  false
                );
              }
            );
          },
          (err) => {
            this.generalService.dialogSuccess("Une erreur se produite", false);
          }
        );
    }
  }
  ordreArticle = 0;
  onChangeImagefile(fileInput, mode) {
    this.file = fileInput.target.files[0];
    var current_file = fileInput.target.files[0];
    var reader = new FileReader();
    if (current_file.type.indexOf("image") == 0) {
      this.enregistrementTerminer = false;
      reader.onload = (e) => {
        var image = new Image();
        image.src = reader.result.toString();
        image.onload = (ev) => {
          var code;
          code = "ImmageBannerCat";
          this.imageToUpload.base64 = this.generalService.redimentionnerImage(
            image,
            1000,
            370,
            80
          );
          this.imageToUpload.code = code;
          this.imageToUpload.name = fileInput.target.files[0].name;
          this.enregistrerImageFixe(this.imageToUpload, "ImageCategorie");
        };
      };
      reader.readAsDataURL(current_file);
    } else
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une image",
        false
      );
  }
  enregistrerImageFixe(imageToUpload, banniere) {
    if (this.initDoc != undefined) {
      this.addFiles(
        this.initDoc,
        imageToUpload.base64,
        imageToUpload,
        imageToUpload.code,
        "ecImage",
        "",
        "crerFichier",
        banniere,
        ""
      );
    } else
      this.generalService.dialogSuccess(
        "veuillez patientez un moment pendant la chargement totale du page ",
        false
      );
  }
  addFiles(
    initDoc,
    File_Content,
    File_Text,
    File_Key,
    File_Type,
    File_Parent,
    clickMode,
    File_Groupe,
    File_Lien
  ) {
    if (this.numberOfImagePerCategorie() < 10) {
      this.generalService.uploadFile2(this.file, this.file.name).subscribe(
        (data1) => {
          var doc = this.generalService.clone(initDoc);
          doc.files[0].File_Parent = File_Parent;
          doc.files[0].File_Content = data1["fileName"];
          doc.files[0].File_Text = File_Text.name;
          doc.files[0].File_Key = File_Key + "_" + this.rowGroupe.ecGroup_Code;
          doc.files[0].File_Type = File_Type;
          doc.files[0].File_Groupe = File_Groupe;
          doc.files[0].File_Lien = File_Lien;
          this.generalService.enregisterTable(doc).subscribe(
            (daat) => {
              this.getImageCategorie();
              this.generalService.dialogSuccess("Document enregisté", true);
              this.enregistrementTerminer = true;
            },
            (err) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess(
                " Une erreur se produite",
                false
              );
            }
          );
        },
        (err) => {
          this.generalService.dialogSuccess("image non enregisté", false);
          this.enregistrementTerminer = true;
        }
      );
    } else {
      this.generalService.dialogSuccess(
        "Seulement 10 image sont autorisé",
        false
      );
      this.enregistrementTerminer = true;
    }
  }

  getImageCategorie() {
    // ImmageBannerCat_1250 key
    this.listeImages = [];
    this.generalService
      .rechercheTable(
        this.generalService.urlListeFilesR2 + "ImageCategorie" + "," + "ecImage"
      )
      .subscribe((img) => {
        this.listeImages = img;
      });
  }

  modifierImage(File_Id, base64, file, text, lien) {
    var name = file.name;
    if (this.generalService.useDataBaseToSaveImage == 0) {
      // File_Content=this.extractContentBetweenQuotes(File_Content.toString())
      // var blob = dataURLToBlob(File);

      console.log("bbbb", file);

      this.generalService.uploadFile2(base64, name).subscribe(
        (data1) => {
          this.generalService
            .rechercheTable(
              this.generalService.urlFiles + "&val=" + File_Id.toString()
            )
            .subscribe((data) => {
              data.Files[0].File_Content = data1["fileName"];
              if (name != "") data.Files[0].File_Text = name;
              if (lien != "") data.Files[0].File_Lien = lien;
              console.log(data);

              this.generalService.enregisterTable(data).subscribe(
                (data2) => {
                  console.log(data2);

                  this.enregistrementTerminer = true;
                  this.generalService.dialogSuccess(text + " enregisté", true);
                  this.enregistrementTerminer = true;
                  this.getImageCategorie();
                },
                (err) => {
                  console.log(err);
                  this.generalService.dialogSuccess(
                    text + " non enregisté",
                    false
                  );
                }
              );
            });
        },
        (err) => {
          this.generalService.dialogSuccess(text + " non enregisté", false);
        }
      );
    } else {
      this.generalService
        .rechercheTable(
          this.generalService.urlFiles + "&val=" + File_Id.toString()
        )
        .subscribe((data) => {
          if (base64 != "") data.Files[0].File_Content = base64;
          if (name != "") data.Files[0].File_Text = name;
          if (lien != "") data.Files[0].File_Lien = lien;
          this.generalService.enregisterTable(data).subscribe(
            (data) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess(text + " enregisté", true);
            },
            (e) => {
              this.generalService.dialogSuccess(text + " non enregisté", false);
            }
          );
        });
    }
  }
  numberOfImagePerCategorie() {
    var len = 0;
    this.listeImages.forEach((element) => {
      if (element.File_Key.includes(this.rowGroupe.ecGroup_Code)) len++;
    });
    return len;
  }
  listeImages = [];
  selectedImageDeatail;
  buttonDisabled: boolean = false;
  selectImageDeatail(id: number) {
    this.selectedImageDeatail = id;
    for (var i = 0; i < this.listeImages.length; i++) {
      $("#" + this.listeImages[i].File_Id).attr("style", "height:150px");
    }
    $("#" + id).attr(
      "style",
      "border-color: blue;   border-style: solid; height:150px"
    );
    console.log(this.selectedImageDeatail);
  }
  supprimerImage() {
    if (this.rowGroupe.ecGroup_Code) {
      if (this.rowGroupe.ecGroup_Icone.length > 0) {
        this.enregistrementTerminer = false;
        this.generalService
          .rechercheTable(
            this.generalService.urlGroup + "&val=" + this.rowGroupe.ecGroup_Code
          )
          .subscribe((groupe) => {
            groupe.ecGroup[0].ecGroup_Icone = null;
            this.generalService.postDs(groupe).subscribe(
              (g) => {
                this.imageCategorieSrc = null;
                this.enregistrementTerminer = true;
                this.generalService.dialogSuccess(
                  "Image supprimé avec succés",
                  true
                );
                this.getGroupes(false);
              },
              (err) => {
                this.enregistrementTerminer = true;
                this.generalService.dialogSuccess("Image non supprimé", false);
              }
            );
          });
      } else {
        this.generalService.dialogSuccess(
          "Groupe ne contient pas d'image",
          false
        );
      }
    } else {
      this.generalService.dialogSuccess("Sélectionner un Groupe ", false);
    }
  }
  supprimer() {
    if (this.selectedImageDeatail != null) {
      var deleteFn = this.generalService.supprimer(
        this.selectedImageDeatail,
        "avtFiles"
      );
      if (deleteFn != null) {
        this.enregistrementTerminer = false;
        this.buttonDisabled = true;
        deleteFn.subscribe(
          (data) => {
            this.listeImages = this.listeImages.filter((img) => {
              return img.File_Id != this.selectedImageDeatail;
            });
            this.generalService.dialogSuccess("Elément supprimer", true);
            this.enregistrementTerminer = true;
            this.buttonDisabled = false;
          },
          (error) => {
            this.generalService.dialogSuccess("Elément non supprimé", false);
            this.enregistrementTerminer = true;
            this.buttonDisabled = false;
          }
        );
      }
    }
  }
  enregistrerTextImage() {
    this.enregistrementTerminer = false;
    this.buttonDisabled = true;
    this.generalService
      .rechercheTable(
        "ds/formdata?code=avtFiles&val=" + this.selectedImageDeatail
      )
      .subscribe(
        (data) => {
          var img = this.listeImages.find((img) => {
            return img.File_Id == this.selectedImageDeatail;
          });
          data.Files[0].File_Text = img.File_Text;
          this.generalService.enregisterTable(data).subscribe(
            (d) => {
              this.buttonDisabled = false;
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Enregistrer", true);
            },
            () => {
              this.buttonDisabled = false;
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Non enregistrer", false);
            }
          );
        },
        () => {
          this.buttonDisabled = false;
          this.enregistrementTerminer = true;
          this.generalService.dialogSuccess("Non enregistrer", false);
        }
      );
  }
  ngOnInit() {
    this.groupeMenue = {};
    if (this.generalService.userConnecter == "") {
      this.router.navigate([""]);
    } else {
      this.getGroupes(true);
      this.getCategories();
      this.getMenu(false);
      this.getArticleMenue(false);
      this.getInitDoc();
      this.getImageCategorie();
    }
  }
  getCategories() {
    this.generalService
      .rechercheTable(this.generalService.urlListeCategorie)
      .subscribe((cat) => {
        this.allCategories = cat.filter((cat) => {
          return cat.categorie_CodeP == null || cat.categorie_CodeP == "";
        });
        this.categories = this.generalService.clone(this.allCategories);
      });
  }
  getArticleMenue(refrechDataSource: boolean) {
    this.generalService
      .rechercheTable(this.generalService.urlListeGroupArt)
      .subscribe((art) => {
        this.allArticlesMenue = art;
        if (refrechDataSource) {
          this.setDataSourceMenue();
        }
      });
  }
  getMenu(refrechDataSource: boolean) {
    this.generalService
      .rechercheTable(this.generalService.urlListeGroupMenu)
      .subscribe((cat) => {
        this.allMenu = cat;
        if (refrechDataSource) {
          this.deselectOldMenue();
          this.deselectOldArticle();
          this.getArticleMenue(true);
        }
      });
  }
  getGroupes(getImageCategorie: boolean) {
    this.generalService
      .rechercheTable(this.generalService.urlListeGroup)
      .subscribe((groupes) => {
        this.allGroupe = groupes;
        groupes.forEach((element, index) => {
          if (element.ecGroup_Statut == 1) {
            this.checkedStatut[index] = true;
          }
          if (element.ecGroup_Pos == 1) {
            this.checkedPos[index] = true;
          }
        });
        // this.allGroupe.forEach(g =>
        // {
        //   if(g.ecGroup_Icone == "" || g.ecGroup_Icone == null)
        //     g.ecGroup_Icone="assets/icon.png"
        // });
        this.dataSourceGroupes = new MatTableDataSource(
          this.generalService.clone(this.allGroupe)
        );
        // if (getImageCategorie) this.getImageCategorie();
      });
  }
  selectRowGroupe(event, row) {
    if (this.allMenu != undefined && this.allArticlesMenue != undefined) {
      var els = document.getElementsByClassName("mat-row");
      Array.prototype.forEach.call(els, function (el) {
        el.style = "";
      });
      event.currentTarget.style = "background-color: #a0bdf3;";
      this.rowGroupe = row;
      this.setSelectedGroup(row);
      this.groupeMenue.ecGroup_Code = row.ecGroup_Code;
      this.setDataSourceMenue();
    } else {
      this.generalService.dialogSuccess(
        "Veuillez patienter pendant le chargement total des donnés",
        false
      );
    }
  }
  lastEvent = null;
  setSelectedGroup(row) {
    this.lastEvent = "selectRow";
    this.groupe.ecGroup_Code = this.generalService.clone(row.ecGroup_Code);
    this.groupe.ecGroup_Label = this.generalService.clone(row.ecGroup_Label);
    this.groupe.ecGroup_Ordre = this.generalService.clone(row.ecGroup_Ordre);
    if (row?.ecGroup_Statut)
      this.groupe.ecGroup_Statut = this.generalService.clone(
        row?.ecGroup_Statut
      );
    if (row?.ecGroup_Pos)
      this.groupe.ecGroup_Pos = this.generalService.clone(row?.ecGroup_Pos);
    if (this.generalService.isNotEmpty(row.Art_Code))
      this.generalService
        .rechercheTable(this.generalService.urlArticle + "&val=" + row.Art_Code)
        .subscribe((article) => {
          this.rechercheComponent.parentVal = article.Art[0];
        });
    else this.rechercheComponent.parentVal = null;
    this.groupe.Art_Code = this.generalService.clone(row.Art_Code);
    this.imageCategorieSrc = this.generalService.clone(row.ecGroup_Icone);
    this.categorieSelected = this.allCategories.find((cat) => {
      return cat.categorie_id == row.id;
    });
  }
  setDataSourceMenue() {
    this.menues = this.allMenu.filter((menu) => {
      return menu.ecGroup_Code == this.rowGroupe.ecGroup_Code;
    });

    var compte = 0;
    this.menues.forEach((menue) => {
      menue["code"] = compte;
      menue["testExpande"] = false;
      compte++;
      var articlesMenu = this.allArticlesMenue.filter((articles) => {
        return (
          articles.ecGroup_Code == this.rowGroupe.ecGroup_Code &&
          articles.ecGroupMenu_Code == menue.ecGroupMenu_Code
        );
      });

      menue["detail"] = articlesMenu;
    });
    this.menues.sort((a, b) => a.ecGroupMenu_Ordre - b.ecGroupMenu_Ordre);
    this.showMenu = true;
    this.dataSourceMenue = new MatTableDataSource(this.menues);
  }
  deselectOldMenue() {
    try {
      $("#" + this.oldIdMenue).attr("style", "");
    } catch (error) {}
    this.oldIdMenue = null;
    this.rowMenue = null;
  }
  selectRowMenu(event, row, id) {
    this.deselectOldMenue();
    this.deselectOldArticle();
    event.currentTarget.style = "background-color: #a0bdf3;";
    this.oldIdMenue = id;
    this.rowMenue = row;
  }
  deselectOldArticle() {
    try {
      $("#" + this.oldIdArticle).attr("style", "");
    } catch (error) {}
    this.oldIdArticle = null;
    this.rowArticle = null;
  }
  selectRowArticles(event, row, id) {
    this.deselectOldArticle();
    event.currentTarget.style = "background-color: #50bdf3;";
    this.oldIdArticle = id;
    this.rowArticle = row;
  }
  ajouterGroupe(f) {
    if (f.controls.groupe_Label.valid && f.controls.groupe_Ordre.valid) {
      var testExiste = this.dataSourceGroupes.data.find((cat) => {
        return cat.ecGroup_Label == this.groupe.ecGroup_Label;
      });
      if (testExiste == undefined) {
        this.enregistrementTerminer = false;
        this.generalService
          .rechercheTable(this.generalService.urlGroup)
          .subscribe(
            (groupe) => {
              this.generalService
                .uploadFile(this.lastFile, this.lastFile.name)
                .subscribe(
                  (data1: any) => {
                    if (data1?.body?.fileName) {
                      groupe.ecGroup[0].ecGroup_Icone = data1?.body?.fileName;
                      groupe.ecGroup[0].Art_Code =
                        this.rechercheComponent.parentVal?.Art_Code;
                      groupe.ecGroup[0].ecGroup_Code = this.groupe.ecGroup_Code;
                      groupe.ecGroup[0].ecGroup_Label =
                        this.groupe.ecGroup_Label;
                      groupe.ecGroup[0].ecGroup_Ordre =
                        this.groupe.ecGroup_Ordre;
                      groupe.ecGroup[0].id =
                        this.categorieSelected.categorie_id;
                      this.generalService.enregisterTable(groupe).subscribe(
                        (g) => {
                          this.getGroupes(false);
                          this.generalService.dialogSuccess(
                            "Groupe enregisté",
                            true
                          );
                          this.enregistrementTerminer = true;
                        },
                        (err) => {
                          this.enregistrementTerminer = true;
                          this.generalService.dialogSuccess(
                            "Groupe non enregisté",
                            false
                          );
                        }
                      );
                    }
                  },
                  (error) => {
                    this.enregistrementTerminer = true;
                    console.log(error);
                  }
                );
            },
            (err) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Groupe non enregisté", false);
            }
          );
        // if(this.dataSourceGroupes.data.length>5)
        // {
        //   $("#tableCategories").addClass("tableClass");
        // }
        // else
        // {
        //   $("#tableCategories").removeClass("tableClass");
        // }
        this.dataSourceGroupes = new MatTableDataSource(
          this.dataSourceGroupes.data
        );
      } else
        this.generalService.dialogSuccess(
          "Veuillez saisir une nouvelle catégorie",
          false
        );
    } else {
      this.generalService.dialogSuccess(
        "Veuillez remplir tout les champs",
        false
      );
    }
  }
  ajouterMenue(f) {
    if (f.controls.menue_Label.valid) {
      var testExiste;

      testExiste = this.dataSourceMenue.data.find((cat) => {
        return cat.ecGroupMenu_Label == this.groupeMenue.ecGroupMenu_Label;
      });
      if (testExiste == undefined) {
        this.enregistrementTerminer = false;
        this.generalService
          .rechercheTable(this.generalService.urlGroupMenu)
          .subscribe(
            (menue) => {
              var code = this.groupeMenue.ecGroupMenu_Code;
              if (!this.generalService.isNotEmpty(code))
                code = (
                  Math.max.apply(
                    null,
                    this.allMenu.map(function (o) {
                      return o.ecGroupMenu_Code;
                    })
                  ) + 1
                ).toString();

              menue.ecGroupMenu[0].ecGroupMenu_Code = code;
              menue.ecGroupMenu[0].ecGroupMenu_Ordre =
                this.groupeMenue.ecGroupMenu_Ordre;
              menue.ecGroupMenu[0].ecGroupMenu_Label =
                this.groupeMenue.ecGroupMenu_Label;
              menue.ecGroupMenu[0].ecGroup_Code = this.groupeMenue.ecGroup_Code;
              console.log(menue);
              this.generalService.enregisterTable(menue).subscribe(
                (g) => {
                  this.enregistrementTerminer = true;
                  this.generalService.dialogSuccess("Menue enregisté", true);
                  this.getMenu(true);
                },
                (err) => {
                  this.generalService.dialogSuccess(
                    "Menue non enregisté",
                    false
                  );
                }
              );
            },
            (err) => {
              this.generalService.dialogSuccess("Menue non enregisté", false);
            }
          );
      } else
        this.generalService.dialogSuccess(
          "Veuillez saisir un nouveau menue",
          false
        );
      this.dataSourceGroupes = new MatTableDataSource(
        this.dataSourceGroupes.data
      );
    }
  }
  modifierMenue(rowMenue, f) {
    if (rowMenue != undefined) {
      if (rowMenue.ecGroupMenu_Label != "") {
        this.enregistrementTerminer = false;
        this.generalService
          .rechercheTable(
            this.generalService.urlGroupMenu +
              "&val=" +
              rowMenue.ecGroupMenu_Code
          )
          .subscribe((menue) => {
            menue.ecGroupMenu[0].ecGroupMenu_Label = rowMenue.ecGroupMenu_Label;
            menue.ecGroupMenu[0].ecGroupMenu_Ordre = rowMenue.ecGroupMenu_Ordre;
            console.log(menue);
            this.generalService.enregisterTable(menue).subscribe(
              (g) => {
                this.enregistrementTerminer = true;
                this.generalService.dialogSuccess("Menue enregisté", true);
                this.setDataSourceMenue();
              },
              (err) => {
                this.generalService.dialogSuccess("Menue non enregisté", false);
              }
            );
          });
      } else {
        this.generalService.dialogSuccess("Veuillez choisir un menue", false);
      }
    } else {
      this.generalService.dialogSuccess(
        "Veuillez sélectionner un menue",
        false
      );
    }
  }
  importer2(id) {
    document.getElementById("input_" + id).click();
  }
  importer(id) {
    document.getElementById(id).click();
  }
  // onChangeImagefile(fileInput,id,element)
  // {
  //   var reader2 = new FileReader();
  //   var src;
  //   reader2.onload = (e) =>
  //   {
  //     src = reader2.result;
  //     var imagee = document.getElementById(id);
  //     var fc = src.toString().length;
  //     if(src.toString().length <500)
  //     {
  //       imagee.setAttribute("src",src);
  //       element.ecGroup_Icone = src;
  //     }
  //     else
  //     {
  //       this.generalService.dialogSuccess("La taille d'image ne doit pas dépasser 499 octets et de 15/15 pixel de résolution",false)
  //       var image = document.getElementById(id);
  //       $("#"+id).val("");
  //       image.setAttribute("src",'assets/icon.png');
  //     }
  //   }
  //   if(fileInput.target.files.length == 0)
  //   {
  //     var image = document.getElementById(id);
  //     $("#"+id).val("");
  //     image.setAttribute("src",'assets/icon.png');
  //   }
  //   else
  //   {
  //     reader2.readAsDataURL(fileInput.target.files[0]);
  //   }
  // }
  checkedStatut = [];
  checkedPos = [];
  onselectionChange(event) {
    this.enregistrementTerminer = false;
    this.generalService
      .rechercheTable(
        this.generalService.urlGroup + "&val=" + this.rowGroupe.ecGroup_Code
      )
      .subscribe(
        (groupe) => {
          event.checked
            ? (groupe.ecGroup[0].ecGroup_Statut = 1)
            : (groupe.ecGroup[0].ecGroup_Statut = 0);
          this.generalService.postDs(groupe).subscribe(
            (g) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Groupe enregisté", true);
            },
            (err) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Groupe non enregisté", false);
            }
          );
        },
        (error) => {
          this.enregistrementTerminer = true;
        }
      );
  }
  onselectionChangeCheckBox(event) {
    this.enregistrementTerminer = false;
    this.generalService
      .rechercheTable(
        this.generalService.urlGroup + "&val=" + this.rowGroupe.ecGroup_Code
      )
      .subscribe(
        (groupe) => {
          event.checked
            ? (groupe.ecGroup[0].ecGroup_Pos = 1)
            : (groupe.ecGroup[0].ecGroup_Pos = 0);
          this.generalService.postDs(groupe).subscribe(
            (g) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Groupe enregisté", true);
            },
            (err) => {
              this.enregistrementTerminer = true;
              this.generalService.dialogSuccess("Groupe non enregisté", false);
            }
          );
        },
        (error) => {
          this.enregistrementTerminer = true;
        }
      );
  }
  modifierGroupe(f) {
    if (this.imageCategorieSrc != undefined) {
      if (this.rowGroupe != undefined) {
        console.log(this.rowGroupe);

        if (
          f.controls.groupe_Label.valid &&
          f.controls.groupe_Ordre.valid &&
          this.lastFile
        ) {
          this.enregistrementTerminer = false;
          console.log(this.lastFile);

          this.generalService
            .uploadFile(this.lastFile, this.lastFile.name)
            .subscribe(
              (data1: any) => {
                if (data1?.body?.fileName) {
                  this.generalService
                    .rechercheTable(
                      this.generalService.urlGroup +
                        "&val=" +
                        this.rowGroupe.ecGroup_Code
                    )
                    .subscribe(
                      (groupe) => {
                        console.log(groupe);
                        console.log(this.imageCategorieSrcAfterUpload);
                        groupe.ecGroup[0].Art_Code = this.rechercheComponent
                          ?.parentVal?.Art_Code
                          ? this.rechercheComponent?.parentVal?.Art_Code
                          : null;
                        groupe.ecGroup[0].ecGroup_Label =
                          this.groupe.ecGroup_Label;
                        groupe.ecGroup[0].ecGroup_Ordre =
                          this.groupe.ecGroup_Ordre;
                        groupe.ecGroup[0].id =
                          this.categorieSelected.categorie_id;
                        groupe.ecGroup[0].ecGroup_Icone = data1?.body?.fileName;
                        this.generalService.postDs(groupe).subscribe(
                          (g) => {
                            this.enregistrementTerminer = true;
                            this.generalService.dialogSuccess(
                              "Groupe enregisté",
                              true
                            );
                            this.getGroupes(false);
                          },
                          (err) => {
                            this.enregistrementTerminer = true;
                            this.generalService.dialogSuccess(
                              "Groupe non enregisté",
                              false
                            );
                          }
                        );
                      },
                      (err) => {
                        console.log(err);
                        this.enregistrementTerminer = true;
                        this.generalService.dialogSuccess(
                          "Groupe non enregisté",
                          false
                        );
                      }
                    );
                }
              },
              (err) => {
                console.log(err);
                this.enregistrementTerminer = true;
                this.generalService.dialogSuccess("Image non enregisté", false);
              }
            );
        } else if (
          f.controls.groupe_Label.valid &&
          f.controls.groupe_Ordre.valid &&
          !this.lastFile
        ) {
          this.generalService
            .rechercheTable(
              this.generalService.urlGroup +
                "&val=" +
                this.rowGroupe.ecGroup_Code
            )
            .subscribe(
              (groupe) => {
                console.log(groupe);
                console.log(this.imageCategorieSrcAfterUpload);
                groupe.ecGroup[0].Art_Code = this.rechercheComponent?.parentVal
                  ?.Art_Code
                  ? this.rechercheComponent?.parentVal?.Art_Code
                  : null;
                groupe.ecGroup[0].ecGroup_Label = this.groupe.ecGroup_Label;
                groupe.ecGroup[0].ecGroup_Ordre = this.groupe.ecGroup_Ordre;
                groupe.ecGroup[0].id = this.categorieSelected.categorie_id;
                groupe.ecGroup[0].ecGroup_Icone = this.rowGroupe.ecGroup_Icone;
                this.generalService.postDs(groupe).subscribe(
                  (g) => {
                    this.enregistrementTerminer = true;
                    this.generalService.dialogSuccess("Groupe modifié", true);
                    this.getGroupes(false);
                  },
                  (err) => {
                    this.enregistrementTerminer = true;
                    this.generalService.dialogSuccess(
                      "Groupe non enregisté",
                      false
                    );
                  }
                );
              },
              (err) => {
                console.log(err);
                this.enregistrementTerminer = true;
                this.generalService.dialogSuccess(
                  "Groupe non enregisté",
                  false
                );
              }
            );
        } else {
          this.generalService.dialogSuccess(
            "Veuillez remplir tout les champs",
            false
          );
        }
      } else {
        this.generalService.dialogSuccess(
          "Veuillez sélectionner une ligne",
          false
        );
      }
    } else {
      this.generalService.dialogSuccess(
        "Veuillez patienter pendant le chargement des données ",
        false
      );
    }
  }
  applyFilter(filterValue: string) {
    this.dataSourceGroupes.filter = filterValue.trim().toLowerCase();
  }
  applyFilterMenue(filterValue: string) {
    this.dataSourceMenue.filter = filterValue.trim().toLowerCase();
  }
  ongroupeValuechange(e) {
    var myList = this.generalService.clone(this.allCategories);
    var list = myList.filter((val) => {
      return (
        val.categorie_Text
          .toLowerCase()
          .indexOf(e.target.value.toLowerCase()) >= 0
      );
    });
    if (list.length == 0) {
      list = myList;
      e.target.value = e.target.value.substr(0, e.target.value.length - 1);
    }
    this.categories = list;
  }
  setTextInput(cat) {
    if (cat) {
      return cat.categorie_Text;
    }
  }
  onGroupeSelected(event) {
    this.categorieSelected = this.allCategories.find((cat) => {
      return cat.categorie_id == event.option.id;
    });
  }
  onGroupeTableSelected(event, element) {
    var testExisteCode = this.allGroupe.find((cat) => {
      return cat.ecGroup_Label == event.option.value;
    });

    if (testExisteCode == undefined) {
      var g = this.allGroupe.find((cat) => {
        return cat.ecGroup_Code == element.ecGroup_Code;
      });
      g.ecGroup_Label = event.option.value;
    } else {
      element.ecGroup_Label = "";
      this.generalService.dialogSuccess(
        "Le groupe " + testExisteCode.ecGroup_Label + " existe déjà",
        false
      );
    }
  }
  isExpansionDetailRow = (i: number, row: Object) => {
    return row.hasOwnProperty("testExpande");
  };
  toggleRow(value: any, obj: any) {
    //this.myIcon
    const foundElement = this.dataSourceMenue.data.find(
      (elem) => elem !== undefined && elem.code === value.code
    );
    //console.log("The found element is " + JSON.stringify(foundElement));
    var index = this.dataSourceMenue.data.indexOf(foundElement);
    this.dataSourceMenue.data[index].testExpande =
      !this.dataSourceMenue.data[index].testExpande;
    if (this.dataSourceMenue.data[index].testExpande)
      obj.currentTarget.innerHTML = "remove";
    else obj.currentTarget.innerHTML = "add";
  }
  supprimerGroupeCategorie() {
    if (this.rowGroupe != undefined) {
      var deleteFn = this.generalService.supprimer(
        this.rowGroupe.ecGroup_Code,
        "ecGroup"
      );
      if (deleteFn != null) {
        this.enregistrementTerminer = false;
        this.disabledBtnSupprimerGroupe = true;
        deleteFn.subscribe(
          (data) => {
            this.getGroupes(false);
            this.generalService.dialogSuccess("Elément supprimer", true);
            this.enregistrementTerminer = true;
            this.disabledBtnSupprimerGroupe = false;
          },
          (error) => {
            this.generalService.dialogSuccess("Elément non supprimé", false);
            this.enregistrementTerminer = true;
            this.disabledBtnSupprimerGroupe = false;
          }
        );
      }
    }
  }
  supprimerArticleMenue() {
    if (this.rowArticle != undefined) {
      var deleteFn = this.generalService.supprimer(
        this.rowArticle.Id,
        "ecGroupArt"
      );
      if (deleteFn != null) {
        this.enregistrementTerminer = false;
        this.disabledBtnSupprimerArticleMenue = true;
        deleteFn.subscribe(
          (data) => {
            this.getMenu(true);
            this.generalService.dialogSuccess("Elément supprimer", true);
            this.enregistrementTerminer = true;
            this.disabledBtnSupprimerArticleMenue = false;
          },
          (error) => {
            this.generalService.dialogSuccess("Elément non supprimé", false);
            this.enregistrementTerminer = true;
            this.disabledBtnSupprimerArticleMenue = false;
          }
        );
      }
    }
  }
  nbrElementSupprimer: number = 0;
  supprimerMenueGroupe(row) {
    // if(this.generalService.userConnecter == "admin")
    if (confirm("Vouler vous supprimer cette elément")) {
      /* si on clique sur ok */
      this.enregistrementTerminer = false;
      this.nbrElementSupprimer = row.detail.length + 1;
      row.detail.forEach((element) => {
        this.generalService
          .supprimerSanMsgConfirm(element.Id, "ecGroupArt")
          .subscribe(
            (data) => {
              this.generalService.dialogSuccess("Elément supprimer", true);
              this.nbrElementSupprimer--;
              if (this.nbrElementSupprimer == 0) this.getMenu(true);
            },
            (error) => {
              this.generalService.dialogSuccess("Elément non supprimé", false);
            }
          );
      });
      this.generalService
        .supprimerSanMsgConfirm(row.ecGroupMenu_Code, "ecGroupMenu")
        .subscribe(
          (data) => {
            this.generalService.dialogSuccess("Elément supprimer", true);
            this.enregistrementTerminer = true;
            this.nbrElementSupprimer--;
            if (this.nbrElementSupprimer == 0) this.getMenu(true);
          },
          (error) => {
            this.generalService.dialogSuccess("Elément non supprimé", false);
            this.enregistrementTerminer = true;
          }
        );
    }
    // else
    //   this.generalService.dialogSuccess("vous n'avez pas le droit de suppression",false)
  }
  modifierArticle() {
    if (this.rowArticle != undefined) {
      this.enregistrementTerminer = false;
      this.generalService
        .rechercheTable(
          this.generalService.urlGroupArt + "&val=" + this.rowArticle.Id
        )
        .subscribe(
          (artGroupe) => {
            artGroupe.ecGroupArt[0].Art_Code = this.parentVal.Art_Code;
            artGroupe.ecGroupArt[0].ecGroupArt[0].ecGroup_Ordre =
              this.ordreArticle;
            console.log(artGroupe);
            this.generalService.enregisterTable(artGroupe).subscribe(
              (artGroupe) => {
                this.enregistrementTerminer = true;
                this.generalService.dialogSuccess("Article enregisté", true);
                this.getMenu(true);
              },
              (err) => {
                this.generalService.dialogSuccess(
                  "Article non enregisté",
                  false
                );
              }
            );
          },
          (err) => {
            this.generalService.dialogSuccess("Article non enregisté", false);
          }
        );
    } else {
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une ligne",
        false
      );
    }
  }
  ajouterArticle() {
    if (this.rowMenue != undefined) {
      var testExisteCode = this.allArticlesMenue.find((art) => {
        return (
          art.ecGroupMenu_Code == this.rowMenue.ecGroupMenu_Code &&
          art.ecGroup_Code == this.rowGroupe.ecGroup_Code &&
          art.Art_Code == this.parentVal.Art_Code
        );
      });
      if (testExisteCode == undefined) {
        this.enregistrementTerminer = false;
        this.generalService
          .rechercheTable(this.generalService.urlGroupArt)
          .subscribe(
            (artGroupe) => {
              artGroupe.ecGroupArt[0].ecGroupMenu_Code =
                this.rowMenue.ecGroupMenu_Code;
              artGroupe.ecGroupArt[0].ecGroup_Code =
                this.rowGroupe.ecGroup_Code;
              artGroupe.ecGroupArt[0].Art_Code = this.parentVal.Art_Code;
              artGroupe.ecGroupArt[0].ecGroup_Ordre = this.ordreArticle;
              console.log(artGroupe);
              this.generalService.enregisterTable(artGroupe).subscribe(
                (artGroupe) => {
                  this.enregistrementTerminer = true;
                  this.generalService.dialogSuccess("Article enregisté", true);
                  this.getMenu(true);
                  this.ordreArticle = 0;
                },
                (err) => {
                  this.generalService.dialogSuccess(
                    "Article non enregisté",
                    false
                  );
                }
              );
            },
            (err) => {
              this.generalService.dialogSuccess("Article non enregisté", false);
            }
          );
      } else {
        this.generalService.dialogSuccess(
          "Veuillez sélectionner  un nouveau article",
          false
        );
      }
    } else {
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une ligne",
        false
      );
    }
  }

  showImageInDataSourceGroupes(imageCategorie) {
    var groupeCategorie = this.dataSourceGroupes.data.find((cat) => {
      return cat.ecGroup_Code == imageCategorie.File_Key;
    });
    if (groupeCategorie != undefined)
      groupeCategorie.File_Content = imageCategorie.File_Content;
  }
  lastFile = null;
  imageCategorieSrcAfterUpload;
  onChangeImagefile2(fileInput) {
    this.enregistrementTerminer = false;
    this.lastEvent = "upload";
    var file = fileInput.target.files[0];
    this.lastFile = fileInput.target.files[0];
    var reader = new FileReader();
    console.log(file.type);
    if (file.type.toString().indexOf("image") == 0) {
      reader.onload = (e) => {
        this.enregistrementTerminer = true;
        this.imageCategorieSrc = reader.result;
        this.imageCategorieName = fileInput.target.files[0].name;
      };
      reader.readAsDataURL(file);
    } else {
      this.enregistrementTerminer = true;
      this.generalService.dialogSuccess(
        "Veuillez sélectionner une image ",
        false
      );
    }
  }
  getInitDoc() {
    this.generalService
      .rechercheTable(this.generalService.urlAvtDoc)
      .subscribe((doc) => {
        this.initDoc = doc;
      });
  }
}
